import createPersistedState from 'vuex-persistedstate';
import { createStore } from 'vuex';

export default createStore({
  state: {
    user: {
      id: '',
      name: '',
      email: '',
      code: ''
    }
  },
  mutations: {
    STORE_USER(state, aUser) {
      state.user.id = aUser.id;
      state.user.name = aUser.name;
      state.user.email = aUser.email;
      state.user.code = aUser.code;
    }
  },
  actions: {},
  plugins: [createPersistedState()],
  modules: {}
});